import { BooleanCons } from 'src/app/constants/const';

export class SucessPayOptions {
    text: SuccessPayText;
    buttons: SuccessPayButtons;
    constructor() {
        this.text = new SuccessPayText();
        this.buttons = new SuccessPayButtons();
    }
}

export class SuccessPayText {
    title: boolean;
    subtitle: boolean;
    icon: boolean;
    processingPayText: boolean;
    discountText: boolean;
    processingTextTransfer: boolean;
    titleTextTransferSpei: boolean;
    titleSpei: boolean;
    subtitleSpei: boolean;
    iconSpei: boolean;
    titlePaynet: boolean;
    subtitlePaynet: boolean;
    iconPaynet: boolean;
    titleTextTransferPaynet: boolean;
    reverseInfo: boolean;
    pricesChange: boolean;
    constructor() {
        this.title = BooleanCons.false;
        this.subtitle = BooleanCons.false;
        this.icon = BooleanCons.false;
        this.processingPayText = BooleanCons.false;
        this.discountText = BooleanCons.false;
        this.processingTextTransfer = BooleanCons.false;
        this.titleTextTransferSpei = BooleanCons.false;
        this.titleTextTransferPaynet = BooleanCons.false;
        this.titleSpei = BooleanCons.false;
        this.subtitleSpei = BooleanCons.false;
        this.iconSpei = BooleanCons.false;
        this.titlePaynet = BooleanCons.false;
        this.subtitlePaynet = BooleanCons.false;
        this.iconPaynet = BooleanCons.false;
        this.reverseInfo = BooleanCons.false;
        this.pricesChange = BooleanCons.false;
    }
}

export class SuccessPayButtons {
    goToOrders: boolean;
    goToHome: boolean;
    accept: boolean;
    goToPendingOrdersAdvisor: boolean;
    goToHomeAdvisor: boolean;
    centerButton: boolean;
    constructor() {
        this.goToOrders = BooleanCons.false;
        this.goToHome = BooleanCons.false;
        this.accept = BooleanCons.false;
        this.goToPendingOrdersAdvisor = BooleanCons.false;
        this.goToHomeAdvisor = BooleanCons.false;
        this.centerButton = BooleanCons.true;
    }
}
